import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UtilsService } from '../../shared/services/util/utils.service';
import { of } from 'rxjs';
import { LoadingService } from '../../shared/services/loading/loading.service';

export const ClientIdGuard: CanActivateFn = () => {
  const load: LoadingService = inject(LoadingService);
  const utilS = inject(UtilsService);
  const router = inject(Router);
  if(!utilS.getClientData().atenea?.entityId){
    router.navigate(['']);
    load.reset();
    return of(false)
  }
  return true;
};
